import {Component, inject, Input, OnInit} from '@angular/core';
import {ButtonPadraoComponent} from '../../components/button-padrao/button-padrao.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-modal-confirmacao',
  standalone: true,
  imports: [
    ButtonPadraoComponent
  ],
  templateUrl: './modal-confirmacao.component.html',
  styleUrl: './modal-confirmacao.component.css'
})
export class ModalConfirmacaoComponent implements OnInit {
  @Input() texto?: string;
  @Input() subTexto?: string;

  private readonly dialog = inject<MatDialogRef<ModalConfirmacaoComponent>>(MatDialogRef);
  public data = inject(MAT_DIALOG_DATA);

  ngOnInit() {
    this.texto = this.data['texto'] ?? 'Os dados não foram salvos. Deseja sair?';
    this.subTexto = this.data['subTexto'];
  }

  continuar(){
    this.dialog.close(false);
  }

  fechar(){
    this.dialog.close(true);
  }
}
